import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Colors, FilterInterface} from '../../interfaces/filter.interface';
import {Store} from '@ngrx/store';
import {first} from 'rxjs/operators';
import {SearchFilterService} from '../../services/search-filter.service';
import {Subscription} from 'rxjs';
import {SelectColors} from '../../store/actions/filter.actions';

@Component({
  selector: 'app-color-filter',
  templateUrl: './color-filter.component.html',
  styleUrls: ['./color-filter.component.scss']
})
export class ColorFilterComponent implements OnInit {
  private subscriptions: Subscription = new Subscription();

  colorsSelected: Colors = {};

  constructor(private store: Store<{ filter: FilterInterface }>, private searchFilterService: SearchFilterService) {
  }

  ngOnInit(): void {
    this.store.select('filter').subscribe((data) => {
      this.colorsSelected = {...data.tags.colors};
    });
    const resetFilter = this.searchFilterService.resetFilters$.subscribe((reset) => {
      if (reset) {
        console.log('reset');
        this.colorsSelected = {};
        this.store.dispatch(SelectColors(this.colorsSelected));
      }
    });
    // this.subscriptions.add(resetFilter);
  }

  handleColorsSelected(color: string): void {
    this.colorsSelected[color] = !this.colorsSelected[color];
    // this.colorsEvent.emit(this.colorsSelected);
    this.store.dispatch(SelectColors(this.colorsSelected));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
